import {observer} from 'mobx-react-lite/dist/index';

export default observer( () => {

    let tracking_head = [];
    let tracking_body, tracking_body_noScript = [];

    // GTM Tracking - FPO-1814 - Head 1 - must be before GTM Head tracking 2 - updated FPO-7076
    tracking_head.push(
        "dataLayer = [{ 'virtpath': 'AiduDe/Live/home', 'clientId': '1544928475.1573480529' }];"
    );

    // GTM Tracking - FPO-1814 - Head 2 - updated FPO-7076
    tracking_head.push(
        "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':"+
        "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],"+
        "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src="+
        "'https://msrmnt.ab-in-den-urlaub.de/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);"+
        "})(window,document,'script','dataLayer','GTM-NCK92VW');"
    );

    // GTM Tracking - FPO-1814 - Body - updated FPO-7076
    tracking_body_noScript.push(
        '<iframe src="https://msrmnt.ab-in-den-urlaub.de/ns.html?id=GTM-NCK92VW" '+
        'height="0" width="0" style="display:none;visibility:hidden"></iframe>'
    );

    // Tracking stuff in <head>
    if (tracking_head) {
        tracking_head.forEach(function(element) {
            let x = document.createElement('script');
            x.textContent = (element);
            document.head.insertBefore(x, document.head.children[0]);
        });
    }

    // Tracking stuff in <body>
    if (tracking_body) {
        tracking_body.forEach(function(element) {
            let x = document.createElement('script');
            x.textContent = (element);
            document.body.insertBefore(x, document.body.children[0]);
        });
    }

    // Tracking noscript stuff in <body>
    if (tracking_body_noScript) {
        tracking_body_noScript.forEach(function(element) {
            let x = document.createElement('noscript');
            x.textContent = (element);
            document.body.insertBefore(x, document.body.children[0]);
        });
    }

    return null;
});
